import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TestItems from "./TestItems";
import BottomMenu from "../bottom-menu/BottomMenu";

function TestList() {
  const { t } = useTranslation();

  return (
    <div className="h-dvh -mx-4">
      <div className="flex flex-col h-dvh flex-1">
        <div className="w-full pt-11 pb-2 px-20">
          <p className="text-2xl font-semibold text-center text-white truncate w-full">
            {t("tests.title")}
          </p>
        </div>

        <div className="flex flex-col gap-y-4 p-4 flex-1 relative overflow-y-auto">
          <TestItems limit={null} showMore={false} />
        </div>
        <div className="mx-4">
          <BottomMenu />
        </div>
      </div>
    </div>
  );
}

export default TestList;
